import { workorderDicionaryError } from '@/core/domain/workorder';
import { ErrorItemQuotation } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.hooks';
import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';

interface Variables {
  items?: {
    id: number;
    type?: WorkOrderItemType;
    isCourtesy?: boolean;
    description?: string;
  }[];
}

interface ItemError {
  itemId: number;
  title: string;
  messages: string[];
}

export function mapWorkOrderItemFieldErrors(
  error: ErrorItemQuotation,
  variables: Variables,
): ItemError[] {
  const fieldErrors = error.response?.data?.fieldErrors;

  if (!fieldErrors || !Object.keys(fieldErrors).length) return [];

  return Object.entries(fieldErrors).map(([itemId, messages]) => {
    const normalizedMessages = messages.map((msgKey) => {
      return workorderDicionaryError[msgKey] ?? msgKey;
    });

    const item = variables.items?.find(
      (item) => item.id === Number(itemId) && !!item.description,
    );

    const title = item?.description || 'Item sem identificação';

    return {
      itemId: Number(itemId),
      title,
      messages: normalizedMessages,
    };
  });
}
